import { FaBox, FaBuilding, FaChartBar, FaHistory, FaProjectDiagram, FaQrcode, FaRecycle, FaHandshake, FaIdCard } from "react-icons/fa";
import { useEffect, useMemo, useState } from "react";
import { FiArchive, FiDatabase, FiFileText } from "react-icons/fi";
import { GrCompliance, GrTemplate } from "react-icons/gr";
import { HiOutlineRectangleStack } from "react-icons/hi2";
import { MdOutlineDashboard, MdOutlineSync } from "react-icons/md";
import { PiMedal } from "react-icons/pi";
import { LuPackage, LuLayers } from "react-icons/lu";
import CommonSidebar from "../../app_components/CommonSidebar";
import { useAuth } from "../../authentication/AuthProvider";
import { useContextProvider } from "../../components/page-context/ContextProvider";
import routing from "../../routing";
const SectorSideBar = () => {
  const { isBuildingEnabled, isProductEnabled, isProjectEnabled, isDppEnabled } = useAuth();
  const { selectedProducts, selectedProjects, selectedBuildings } = useContextProvider();
  const hasSelectedProducts = useMemo(() => selectedProducts.length > 0, [selectedProducts]);
  const hasSelectedProjects = useMemo(() => selectedProjects.length > 0, [selectedProjects]);
  const hasSelectedBuildings = useMemo(() => selectedBuildings.length > 0, [selectedBuildings]);

  const [productPulse, setProductPulse] = useState(0);
  const [projectPulse, setProjectPulse] = useState(0);
  const [buildingPulse, setBuildingPulse] = useState(0);

  const [isWorkspaceActive, setIsWorkspaceActive] = useState(false);

  useEffect(() => {
    if (selectedProducts.length > 0) {
      setProductPulse((p) => p + 1);
      setIsWorkspaceActive(true);
      const timer = setTimeout(() => setIsWorkspaceActive(false), 10000);
      return () => clearTimeout(timer);
    }
  }, [selectedProducts]);

  useEffect(() => {
    if (selectedProjects.length > 0) {
      setProjectPulse((p) => p + 1);
      setIsWorkspaceActive(true);
      const timer = setTimeout(() => setIsWorkspaceActive(false), 10000);
      return () => clearTimeout(timer);
    }
  }, [selectedProjects]);

  useEffect(() => {
    if (selectedBuildings.length > 0) {
      setBuildingPulse((p) => p + 1);
      setIsWorkspaceActive(true);
      const timer = setTimeout(() => setIsWorkspaceActive(false), 10000);
      return () => clearTimeout(timer);
    }
  }, [selectedBuildings]);
  const tabs = useMemo(
    () => [
      {
        label: "Products",
        value: "products",
        icon: LuPackage,
        subHeader: "Features",
        rootPath: routing.sector.products.root,
        path: routing.sector.products.dashboard,
        visibility: isProductEnabled,
        subTabs: [
          { label: "Dashboard", value: "dashboard", icon: MdOutlineDashboard, path: routing.sector.products.dashboard, visibility: isProductEnabled },
          { label: "Workspace", value: "workspace", icon: FiDatabase, path: routing.sector.products.workspace, visibility: hasSelectedProducts, pulse: productPulse, showBorder: isWorkspaceActive },
          { label: "Reuse Workspace", value: "reuse_workspace", icon: MdOutlineSync, path: routing.sector.products.reuse_workspace, visibility: hasSelectedProducts },
          { label: "Comparison", value: "comparison", icon: FaChartBar, path: routing.sector.products.comparison, visibility: isProductEnabled },
          { label: "Circularity", value: "circularity", icon: FaRecycle, path: routing.sector.products.circularity, visibility: hasSelectedProducts },
          { label: "Supplier Portal", value: "supplier_portal", icon: FaHandshake, path: routing.sector.products.supplier_portal, visibility: hasSelectedProducts },
          { label: "Product Digital Passport", value: "digital_passport", icon: FaIdCard, path: routing.sector.products.digital_passport, visibility: hasSelectedProducts && isDppEnabled },
          // { label: "Pre-Built Template", value: "pre_built_template", icon: GrTemplate, path: routing.sector.products.pre_built_template, visibility: isProductEnabled },
          // { label: "EPD/DPP Library", value: "epd_dpp_library", icon: LuLibrary, path: routing.sector.products.epd_dpp_library, visibility: isProductEnabled },
          // { label: "Archive", value: "archive", icon: FiArchive, path: routing.sector.products.archive, visibility: isProductEnabled },
          // {
          //   label: "Collaborate",
          //   value: "collaborate",
          //   icon: FiArchive,
          //   path: routing.sector.products.collaborate,
          //   visibility: true,
          // },
        ],
      },
      {
        label: "Projects",
        value: "projects",
        icon: LuLayers,
        subHeader: "Features",
        rootPath: routing.sector.projects.root,
        path: routing.sector.projects.dashboard,
        visibility: isProjectEnabled,
        subTabs: [
          { label: "Dashboard", value: "dashboard", icon: MdOutlineDashboard, path: routing.sector.projects.dashboard, visibility: isProjectEnabled },
          { label: "Workspace", value: "workspace", icon: FiDatabase, path: routing.sector.projects.workspace, visibility: hasSelectedProjects, pulse: projectPulse, showBorder: isWorkspaceActive },
          { label: "Comparison", value: "comparison", icon: FaChartBar, path: routing.sector.projects.comparison, visibility: isProjectEnabled },
          { label: "Circularity", value: "circularity", icon: FaRecycle, path: routing.sector.projects.circularity, visibility: hasSelectedProjects },
          { label: "Supplier Portal", value: "supplier_portal", icon: FaHandshake, path: routing.sector.projects.supplier_portal, visibility: hasSelectedProjects },
          { label: "Project Digital Passport", value: "digital_passport", icon: FaIdCard, path: routing.sector.projects.digital_passport, visibility: hasSelectedProjects && isDppEnabled },
          // { label: "Pre-Built Template", value: "pre_built_template", icon: GrTemplate, path: routing.sector.projects.pre_built_template, visibility: isProjectEnabled },
          // { label: "Archive", value: "archive", icon: FiArchive, path: routing.sector.projects.archive, visibility: isProjectEnabled },
        ],
      },
      {
        label: "Buildings",
        value: "buildings",
        icon: FaBuilding,
        subHeader: "Features",
        rootPath: routing.sector.buildings.root,
        path: routing.sector.buildings.dashboard,
        visibility: isBuildingEnabled,
        subTabs: [
          { label: "Dashboard", value: "dashboard", icon: MdOutlineDashboard, path: routing.sector.buildings.dashboard, visibility: true },
          { label: "Workspace", value: "workspace", icon: FiDatabase, path: routing.sector.buildings.workspace, visibility: hasSelectedBuildings, pulse: buildingPulse, showBorder: isWorkspaceActive },
          // LEED
          { label: "LEED", value: "leed", icon: PiMedal, path: routing.sector.buildings.leed, visibility: hasSelectedBuildings },
          // Net Zero
          { label: "Net Zero", value: "net_zero", icon: GrCompliance, path: routing.sector.buildings.net_zero, visibility: hasSelectedBuildings },
          // Comparison
          { label: "Comparison", value: "comparison", icon: FaChartBar, path: routing.sector.buildings.comparison, visibility: true },
          // Circularity
          { label: "Circularity", value: "circularity", icon: FaRecycle, path: routing.sector.buildings.circularity, visibility: hasSelectedBuildings },
          { label: "Building Digital Passport", value: "digital_passport", icon: FaIdCard, path: routing.sector.buildings.digital_passport, visibility: hasSelectedBuildings && isDppEnabled },
          { label: "Pre-Built Template", value: "pre_built_template", icon: GrTemplate, path: routing.sector.buildings.pre_built_template, visibility: true },
          { label: "Archive", value: "archive", icon: FiArchive, path: routing.sector.buildings.archive, visibility: false },
        ],
      },
      {
        label: "Compliance",
        value: "compliance",
        icon: GrCompliance,
        subHeader: "Features",
        rootPath: routing.sector.compliance.root,
        path: routing.sector.compliance.sbti,
        visibility: false,
        subTabs: [
          { label: "SBTI", value: "sbti", icon: PiMedal, path: routing.sector.compliance.sbti, visibility: true },
          { label: "CDP", value: "cdp", icon: PiMedal, path: routing.sector.compliance.cdp, visibility: true },
          { label: "EcoVadis", value: "eco_vadis", icon: PiMedal, path: routing.sector.compliance.eco_vadis, visibility: true },
          { label: "LEED", value: "leed", icon: PiMedal, path: routing.sector.compliance.leed, visibility: true },
        ],
      },
      {
        label: "Digital Passport",
        value: "digital_passport",
        icon: FiFileText,
        subHeader: "FEATURES",
        rootPath: routing.digital_passport.root,
        path: routing.digital_passport.dashboard,
        visibility: isDppEnabled,
        subTabs: [
          { label: "Dashboard", value: "dashboard", icon: MdOutlineDashboard, path: routing.digital_passport.dashboard, visibility: isDppEnabled },
          { label: "Stats", value: "stats", icon: FaChartBar, path: routing.digital_passport.stats, visibility: isDppEnabled },
          { label: "History", value: "history", icon: FaHistory, path: routing.digital_passport.history, visibility: hasSelectedProducts && isDppEnabled },
        ],
      },
    ],
    [isProductEnabled, isProjectEnabled, isBuildingEnabled, isDppEnabled, hasSelectedProducts, hasSelectedProjects, hasSelectedBuildings, productPulse, projectPulse, buildingPulse, isWorkspaceActive]
  );

  return <CommonSidebar tabs={tabs} />;
};

export default SectorSideBar;
